import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { cx } from '@emotion/css'
import MuiContainer from '@mui/material/Container'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/system'
import Head from 'next/head'
import AboveTheFold from '../../particles/above-the-fold'
import { ImageBackground } from '../../particles/image'
import { Root, StickyWrapper } from './guest-nested-layout.styled'

const GuestNestedLayout = ({ children, layout }) => {
	const {
		guestNestedLayout: { image: { src: imageSrc, height: imageHeight, width: imageWidth, alt: imageAlt } = {} } = {},
	} = useConfig()

	const { cssClass } = layout
	const theme = useTheme()
	const mdUp = useMediaQuery(theme.breakpoints.up('md'))

	return (
		<>
			<Head>
				<meta name="robots" content="noindex,nofollow" />
			</Head>
			<Root className={cx('guest-nested-layout', cssClass)}>
				{mdUp && imageSrc ? (
					<StickyWrapper>
						<AboveTheFold updateHeightOnInteraction>
							<ImageBackground
								alt={imageAlt}
								src={imageSrc}
								originalHeight={imageHeight}
								originalWidth={imageWidth}
								style={{
									width: '100%',
									height: '100%',
								}}
							/>
						</AboveTheFold>
					</StickyWrapper>
				) : null}
				<MuiContainer className="guest-nested-layout-container" disableGutters maxWidth={imageSrc ? 'lg' : false}>
					{children}
				</MuiContainer>
			</Root>
		</>
	)
}

export default GuestNestedLayout
